import {clone_form_group} from './form_group_cloner.js'

$(document).ready ->
  if $('body').is('body.orders')
    $('a#add_position').click ->
      form_group = $('input#order_invoice_positions').last().closest('.form-group')
      clone_form_group form_group, input: '', label: 'Zusatzposition'
